export const hooks = {
  'Code validated successfully!': 'Código validado com sucesso!',
  'Error, something unexpected happened': 'Erro, algo inesperado aconteceu',
  'Invalid code!': 'Código inválido!',
};
